import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const checkAssetTenderItems = createAsyncThunk(
    "assetTenderCheck/checkAssetTenderItems",
    async (itemId, { rejectWithValue }) => {
        try {
            const response = await axiosHttp.get(`tms/tenders/asset/${itemId}`);
            return response.data;
        } catch (err) {
            if (!err.response) throw err;
            return rejectWithValue(err.response.data);
        }
    }
);

const AssetTenderCheckSlice = createSlice({
    name: "AssetTenderCheckSlice",
    initialState: {
        isLoading: false,
        hasTenderItems: false,
        count: 0,
        data: null,
        error: null,
    },
    reducers: {
        resetAssetTenderCheck: (state) => {
            state.isLoading = false;
            state.hasTenderItems = false;
            state.count = 0;
            state.data = null;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(checkAssetTenderItems.pending, (state) => {
                state.isLoading = true;
                state.hasTenderItems = false;
                state.count = 0;
                state.data = null;
                state.error = null;
            })
            .addCase(checkAssetTenderItems.fulfilled, (state, action) => {
                state.isLoading = false;
                state.hasTenderItems = action.payload?.count > 0;
                state.count = action.payload?.count || 0;
                state.data = action.payload?.data || [];
            })
            .addCase(checkAssetTenderItems.rejected, (state, action) => {
                state.isLoading = false;
                state.hasTenderItems = false;
                state.count = 0;
                state.error = action.payload;
            });
    },
});

export const { resetAssetTenderCheck } = AssetTenderCheckSlice.actions;
export default AssetTenderCheckSlice.reducer;
